import { gql } from '@apollo/client';

export default gql`
    query($offset:Int!, $admin: String){
        InstrumentLimit(offset: $offset, admin: $admin) {
            IdInstrumento
            Instrumento
        }
    }
`;